$(document).ready(function () {
    if ($(".post-content").length){
        const readingProgress = (contentArea, progressBar) => {
            const content = document.querySelector(contentArea);
            const progress = document.querySelector(progressBar);

            const frameListening = () => {
                const contentBox = content.getBoundingClientRect();
                const midPoint = window.innerHeight / 2;
                const minsRemaining = Math.round(progress.max - progress.value);

                if (contentBox.top > midPoint) {
                    progress.value = 0;
                }

                if (contentBox.top < midPoint) {
                    progress.value = progress.max;
                }

                if (contentBox.top <= midPoint && contentBox.bottom >= midPoint) {
                    progress.value =
                        (progress.max * Math.abs(contentBox.top - midPoint)) /
                        contentBox.height;
                }

                window.requestAnimationFrame(frameListening);
            };

            window.requestAnimationFrame(frameListening);
        };

        readingProgress(".post-fixed", ".reading-progress-bar");
    }

    if ($(".toc-list ").length){
        $(".toc-heading").css({"display": "block"});
    } else {
        $(".toc-heading").css({"display": "none"});
    }
    $(window).on("load resize scroll", function (e) {
        var sticky = $(".header"),
            scroll = $(window).scrollTop();
        if (scroll >= 100) {
            sticky.addClass("fixed");
        } else {
            sticky.removeClass("fixed");
        }
    });
// SCROLL FOR ALL LINKS (:NOT NAVIGATION)
    var headerHeight = $('header').height();
    $( "a.footer__nav-scroll" ).click(function( event ) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top - headerHeight - 40}, 500);
    });



});

$('.menu').css("display","none");
$(".button--contact").click(function () {
    $('.menu').hide();
    $('body').removeClass('hidden');
    $('#hamburger').removeClass('opened');
});
$("#hamburger").click(function () {
    $('.menu').toggle(500);
    $('body').toggleClass('hidden');
    $(this).toggleClass('opened');
});
